import React from "react";

import IconDelete from "@material-ui/icons/Delete";
import IconRotate from "@material-ui/icons/RotateRight";
import IconScale from "@material-ui/icons/UnfoldMore";
import IconEdit from "@material-ui/icons/Edit";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth/withWidth";
import Typography from "@material-ui/core/Typography/Typography";

import { Services } from "@configuratorware/configurator-frontendgui/App/ServiceLocator";
import {
  CanvasStateProvider,
  withCanvasState,
} from "redhotmagma-graphics-editor/CanvasInterface/CanvasProvider";
import AddVisualElement from "@configuratorware/configurator-frontendgui/App/Modules/Designer/Containers/AddVisualElement";
import { DefaultDesigner } from "@configuratorware/configurator-frontendgui/App/Modules/Designer/DesignerUI";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import FreePositionCheck from "../Components/FreePositionCheck";

const ButtonContainer = ({ children }) => <Grid xs={6}>{children}</Grid>;

const StandardToolboxWithCanvasState = withWidth()(
  withCanvasState(({ canvas, width }) => {
    return !isWidthUp("sm", width) ? null : (
      <div
        className="noShrink"
        style={{ paddingTop: 8, pointerEvents: "none" }}
      >
        <AddVisualElement
          canvas={canvas}
          components={{ ButtonContainer }}
          renderAddImageLabel={({ classes }) => (
            <React.Fragment>
              <b>{t("addVisualElement.image")}</b>
              <Icon
                classes={{
                  root: classes.AddVisualElementIconRoot,
                }}
              >
                image
              </Icon>
            </React.Fragment>
          )}
          renderAddTextLabel={({ classes }) => (
            <React.Fragment>
              <b>{t("addVisualElement.text")}</b>
              <Icon>text_format</Icon>
            </React.Fragment>
          )}
        />
      </div>
    );
  })
);

const renderStandardToolbox = ({ upload, components: { StandardToolbox } }) => (
  <FreePositionCheck>
    <StandardToolbox {...{ upload }}>
      {({ canvas }) => (
        <CanvasStateProvider canvas={canvas}>
          <StandardToolboxWithCanvasState canvas={canvas} />
        </CanvasStateProvider>
      )}
    </StandardToolbox>
  </FreePositionCheck>
);

const toolboxButtonStyle = {
  width: 40,
  height: 40,
  padding: 0,
  border: "1px solid rgba(0,0,0,0.23)",
  boxSizing: "border-box",
  borderRadius: 3,
  background: "white",
  outline: 0,
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  color: "black",
};

const transformTopRight = { transform: "translate(0%, -100%)" };
const transformBottomRight = { transform: "translate(0%, 0%)" };
const transformBottomLeft = { transform: "translate(-100%, 0%)" };
const transformTopLeft = { transform: "translate(-100%, -100%)" };

const onEditClick = (canvas, selectedObject) => {
  Services.designer.openImageEditDialog(
    selectedObject.imageData.identifier,
    canvas
  );
};

const renderInlineToolButton = ({
  positionName,
  onScalingChange,
  onRotationChange,
  onDeleteClick,
  components: { InlineToolboxButton },
  canvas,
  selectedObject,
}) => {
  switch (positionName) {
    case "topRight":
      return (
        <InlineToolboxButton
          style={{ ...toolboxButtonStyle, ...transformTopRight }}
          onTouchStart={onRotationChange}
          onMouseDown={onRotationChange}
        >
          <IconRotate style={{ alignSelf: "center" }} />
        </InlineToolboxButton>
      );
    case "bottomRight":
      return (
        <InlineToolboxButton
          style={{ ...toolboxButtonStyle, ...transformBottomRight }}
          onTouchStart={onScalingChange}
          onMouseDown={onScalingChange}
        >
          <IconScale
            style={{ transform: "rotate(-45deg)", alignSelf: "center" }}
          />
        </InlineToolboxButton>
      );
    case "bottomLeft":
      return (
        <InlineToolboxButton
          style={{ ...toolboxButtonStyle, ...transformBottomLeft }}
          onClick={onDeleteClick}
        >
          <IconDelete style={{ alignSelf: "center" }} />
        </InlineToolboxButton>
      );
    case "topLeft":
      return (
        selectedObject &&
        selectedObject.type === "Image" && (
          <InlineToolboxButton
            style={{ ...toolboxButtonStyle, ...transformTopLeft }}
            onClick={() => onEditClick(canvas, selectedObject)}
          >
            <IconEdit style={{ alignSelf: "center" }} />
          </InlineToolboxButton>
        )
      );
  }
};

const renderAngleLabel = (angleLabel) => <Typography>{angleLabel}</Typography>;

const renderInlineToolbox = ({ components: { InlineToolbox } }) => (
  <InlineToolbox
    renderToolboxButton={renderInlineToolButton}
    renderAngleLabel={renderAngleLabel}
  />
);

export const CustomDesigner = (props) => (
  <DefaultDesigner
    renderStandardToolbox={renderStandardToolbox}
    renderInlineToolbox={renderInlineToolbox}
    {...props}
  />
);
